import React from 'react';
import { Field } from 'formik';

import InputField from 'buyside/components/presentation/Form/Field/InputField/inputField';

const InvestmentCriteriaForm = () => {
  return (
    <div>
      <Field
        component={InputField}
        name="allocatorProfile.investmentCriteria"
        type="textarea"
        label="Investment Criteria"
      />
    </div>
  );
};

export default InvestmentCriteriaForm;
